import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const containerDetailsActions = createActionGroup({
  source: 'Einreichung - container details',
  events: {
    'Load': props<{ containerId: string }>(),
    'Load success': props<{ container: any }>(),
    'Load failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
